<p class="debugMessage"><small>Profile-Manage:</small></p>
<div class="main-users-div">
	<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
		<div class="alignRow">
			<span mat-icon-button class="alignRow">
				<mat-icon>person</mat-icon>
			</span>
			<span><b>Manage Users</b></span>
		</div>
		<span class="me-auto"></span>
		<app-filter-box (search)="applyFilter($event)" PlaceHolder="Filter Users List" />
		<span mat-icon-button (click)="getAllUsers()" style="outline: none !important;">
			<mat-icon title="Refresh List">refresh</mat-icon>
		</span>
	</nav>

	<ejs-splitter #horizontal height="calc(100vh - var(--navBar-Height) - 120px)" separatorSize=4 width='100%'>
		<e-panes>
			<e-pane size='30%' min='5%' *ngIf="userDataSource && userDataSource.filteredData">
				<ng-template #content>
					<div class="userListMobile">
						<div style="overflow-y: auto;">
							<!-- [ngStyle]="selectedGUID == user.userGUID && {'background-color': 'lightgrey'}" -->
							<div class="registeredUserGrid gridRow rounded"
								*ngFor="let user of userDataSource.filteredData"
								style="padding-left: 0.2em; padding-right: 0.1em;" [routerLink]="user?.UserGUID"
								(click)="SelectUser(user?.UserGUID)">
								<span class="gridImage">
									<img [src]="user?.Picture"
										class="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
										alt="Profile Image" />
								</span>
								<span class="gridHeadingName">User Name:</span>
								<span class="gridName">
									<span>{{user.Name}}</span>
									<small *ngIf="user.AdminSite">Site Admin</small>
									<small *ngIf="user.AdminSystems">System Admin</small>
									<small *ngIf="user.Disabled" style="background-color:lightcoral;">Disabled</small>
								</span>
								<!-- <span class="gridHeadingDisplayName">Nick Name:</span><span class="gridDisplayName">{{user.NickName}}</span> -->
								<span class="gridHeadingEmail">Email:</span><span
									class="gridUser-Email">{{user.Email}}</span>
								<span class="gridHeadingAccessLevel">Access level:</span><span
									class="gridAccessLevel">{{getSafeAccessLevelLabel(user.AccessLevel)}}</span>
							</div>
						</div>
						<div style="width:100%;text-align:center;padding-top: .5em;">
							<mat-label>
								Viewing {{userDataSource.filteredData.length}} of {{appUsers.length}} users
							</mat-label>
						</div>
					</div>
				</ng-template>
			</e-pane>
			<e-pane size='70%' min='5%'>
				<ng-template #content>
					<router-outlet></router-outlet>
				</ng-template>
			</e-pane>
		</e-panes>
	</ejs-splitter>
</div>
